export default "__VITE_ASSET__3b1f6feb__"